import React from "react";
import { FileText, Users, Calendar, Database } from "lucide-react";
import TableCard from "./TableCard";

export default function TableList({ tables, onTableClick, onRefresh }) {
  if (tables.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-16">
        <div className="text-center">
          <Database className="w-16 h-16 mx-auto mb-4 text-gray-300" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            테이블이 없습니다
          </h3>
          <p className="text-gray-500">
            새 테이블을 생성하여 재무 데이터를 관리하세요.
          </p>
        </div>
      </div>
    );
  }

  // Group tables by permission level
  const groupedTables = {
    owner: tables.filter((t) => t.permission_level === "owner"),
    admin: tables.filter((t) => t.permission_level === "admin"),
    edit: tables.filter((t) => t.permission_level === "edit"),
    view: tables.filter((t) => t.permission_level === "view"),
  };

  const sections = [
    {
      key: "owner",
      title: "내가 생성한 테이블",
      icon: FileText,
      color: "blue",
    },
    { key: "admin", title: "관리자 권한", icon: Users, color: "purple" },
    { key: "edit", title: "편집 권한", icon: Calendar, color: "green" },
    { key: "view", title: "조회 권한", icon: Database, color: "gray" },
  ];

  return (
    <div className="space-y-8">
      {sections.map(({ key, title, icon: Icon, color }) => {
        const sectionTables = groupedTables[key];
        if (sectionTables.length === 0) return null;

        return (
          <div key={key} className="space-y-4">
            <div className="flex items-center gap-3">
              <Icon className={`w-5 h-5 text-${color}-600`} />
              <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
              <span className="text-sm text-gray-500">
                ({sectionTables.length})
              </span>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {sectionTables.map((table) => (
                <TableCard
                  key={table.id}
                  table={table}
                  onClick={() => onTableClick(table.id)}
                  onRefresh={onRefresh}
                />
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
